import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const VOLTAGE_DECIMALS = { axis: 0, tooltip: 1 };

// 210-270 V is normal supply; outside it is low or high voltage.
const VOLTAGE_RANGE = {
  low: 210,
  high: 270,
  normalLabel: "Normal",
  outLabel: "Low / high voltage",
  lowLabel: "Low voltage",
  highLabel: "High voltage",
};

export default function VoltageLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="v"
      name="Voltage"
      image={images.chartVoltage}
      iconBackgroundColor="rgba(255, 179, 0, 0.14)"
      unit="V"
      axisTitle="Volts (V)"
      range={VOLTAGE_RANGE}
      decimals={VOLTAGE_DECIMALS}
    />
  );
}
